// extracted by mini-css-extract-plugin
export var smallSpinner = "_rr-0";